import React, { useEffect, useReducer, useState } from 'react';
import {
  SimulatorContainer,
  SimulatorWrapper,
  SimulatorContent,
  SimulatorHeader,
  SimulatorHaderTitle,
  SimulatorHaderGrid,
  SimulatorSelectContainer,
  SimulatorSelectShowOptionSelect,
  SimulatorSelectShowOptionSelected,
  SimulatorSelectShowOptionContent,
  SimulatorSelectShowOptionSelectOption,
  SimulatorSelectShowOptionSelectedMessageError,
  SimulatorSelectLabel,
  SimulatorSelectActiveOption,
  SimulatorSelectOficeLabel, Container, SimulatorSelectOficeLabelBlack, SimulatorSelectOfficeImg
} from './styles';
import { H4 } from '../../components/Typography/styles';
import { BsChevronDown } from 'react-icons/bs';
import { getDesks, getPiloto } from '../../services/desk';
import { HabeasDataSenderContext } from '../../store/';
import { BsInfo } from 'react-icons/bs';
import ModalAction from '../../components/ModalAction';
import simulatorReducer from '../../store/AgileSimulator';
import HabeasDataSenderForm from './HabeasDataSenderForm';
import INITIAL_STATE_HABEASDATA_SENDER from '../../store/HabeasDataSender/state';
import Copyright from '../../components/Copyright';
import { credits, contactMeans, habeasDataSenderSteps } from '../../helpers/enum';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import NewFormSteps from '../../components/FormStepsSimulator';
import Loader from '../../components/Loader';
import { useLocation } from 'react-router-dom';
import { getSimulacionById } from '../../services/simulation';
import { default as SimulatorTypes } from '../../store/AgileSimulator/types';
import { formatPhone } from '../../helpers/string';
import { handleChangeIdentification } from '../../helpers/price';
import SelectOffice from '../../components/SelectOffice';
import SelectOfficeImg from '../../assets/images/SelectOfficeImg.svg'
import SearchField from '../../components/SearchField';
import SearchFieldOffice from '../../components/SearchFieldOffice';
import { isPricing } from '../../services/tasas';
import habeasDataSenderReducer from '../../store/HabeasDataSender';
import HabeasDataIdentityForm from './HabeasDataIdentitySender';
import { getObligatorieadadImagenesCedula } from '../../services/habeasData';
import { default as HabeasDataSenderTypes } from '../../store/HabeasDataSender/types';

const HabeasDataSenderPage = () => {
  const location = useLocation();
  const [habeasDataSender, setHabeasDataSender] = useReducer(habeasDataSenderReducer, INITIAL_STATE_HABEASDATA_SENDER);
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const [activeStep, setActiveStep] = useState(habeasDataSenderSteps.DEFAULT);
  const [lastStep, setLastStep] = useState(habeasDataSenderSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [twoSteps, setTwoSteps] = useState(false);

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      const obligatorieadad = await getObligatorieadadImagenesCedula();
      setTwoSteps(obligatorieadad.data);
      if (!(habeasDataSender.identityPhoto)) habeasDataSender.identityPhoto = [];
      setHabeasDataSender({
        type: HabeasDataSenderTypes.SET_TWO_STEPS,
        twoSteps: obligatorieadad.data
      })
      if(obligatorieadad.data){
        setActiveStep(habeasDataSenderSteps.IDENTIFICATION_FORM)
      }else{
        setActiveStep(habeasDataSenderSteps.CONTACT_FORM)
      }
      
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <SimulatorContainer id="simulator-page">
      <SimulatorWrapper>
        <SimulatorHeader>
          <SimulatorHaderTitle>Autorización</SimulatorHaderTitle>
          <SimulatorHaderGrid>
            <H4 color="#2A2C31">Habeas Data</H4>
          </SimulatorHaderGrid>
        </SimulatorHeader>

        {isLoading ? <Loader /> : (
          <>
            <SimulatorContent style={{ display: 'grid', marginTop: '5px' }}>
              {<NewFormSteps lastStep={lastStep} steps={twoSteps ? 
              [
                { number: habeasDataSenderSteps.IDENTIFICATION_FORM, label: 'Sube la cédula' },
                { number: habeasDataSenderSteps.CONTACT_FORM, label: 'Datos básicos' }
              ]
              :
              [
                { number: habeasDataSenderSteps.IDENTIFICATION_FORM, label: 'Datos básicos' }
              ] 
               } />}

              <HabeasDataSenderContext.Provider value={{ habeasDataSender, setHabeasDataSender }}>

                {activeStep === habeasDataSenderSteps.CONTACT_FORM && (
                  <HabeasDataSenderForm
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                  />
                )}

                {activeStep === habeasDataSenderSteps.IDENTIFICATION_FORM && (
                  <HabeasDataIdentityForm
                    setActiveStep={setActiveStep}
                    setLastStep={setLastStep}
                  />
                )}

              </HabeasDataSenderContext.Provider>
            </SimulatorContent>
          </>
        )}
      </SimulatorWrapper>
      <Copyright />
    </SimulatorContainer>

  )
}

export default HabeasDataSenderPage;
